import { jsx as r } from "react/jsx-runtime";
import { createContext as i, useMemo as l } from "react";
import { ModalProvider as d } from "../Modal/index.js";
import { I18nProvider as m } from "react-aria";
var c = i(null),
  p = function p(_ref) {
    var t = _ref.children,
      o = _ref.Link,
      e = _ref.Image;
    var n = l(function () {
      return {
        Link: o,
        Image: e
      };
    }, [o, e]);
    return /* @__PURE__ */r(m, {
      locale: "en-US",
      children: /* @__PURE__ */r(c.Provider, {
        value: n,
        children: /* @__PURE__ */r(d, {
          children: t
        })
      })
    });
  };
export { c as Context, p as default };